import React from 'react';
import FormField from '../FormField';

export default function CulturaEsporteLazer() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual da cultura, do esporte e do lazer no município.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="cultura_esporte_lazer_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual da cultura, do esporte e do lazer, considerando patrimônio, equipamentos, eventos, economia criativa, praças e programas municipais"
          helpText="Considere patrimônio, equipamentos, eventos, economia criativa, praças e programas municipais"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="cultura_esporte_lazer_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe os principais indicadores encontrados, como bens culturais, equipamentos ativos, eventos, programas, praças e público atendido, sempre com ano de referência"
          helpText="Bens culturais, equipamentos ativos, eventos, programas, praças e público atendido, sempre com ano de referência"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="cultura_esporte_lazer_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados nas áreas de cultura, esporte e lazer"
          helpText="Principais problemas identificados nas áreas de cultura, esporte e lazer"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="cultura_esporte_lazer_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas para preservação, equipamentos, eventos, programas, praças e economia criativa"
          helpText="Considere preservação, equipamentos, eventos, programas, praças e economia criativa"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao8"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao8"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
